import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Card,
  Col,
  Modal,
  Form,
  Button,
  Offcanvas,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Breadcrumb from "Common/BreadCrumb";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Flatpickr from "react-flatpickr";
import {
  useAddRendezvousMutation,
  useDeleteRendezvousMutation,
  useFetchRendezvousQuery,
  useBulkDeleteRendezvousMutation,
} from "features/rendezvous/rendezvousSlice";

import Select from "react-select";
import UpdateRendezvous from "./UpdateRendezvous";
import { French } from "flatpickr/dist/l10n/fr";
import { formatDate, formatTime } from "helpers/data_time_format";
import { useFetchParentsQuery } from "features/parents/parentSlice";
import {
  useFetchSmsSettingsQuery,
  useUpdateSmsSettingByIdMutation,
} from "features/smsSettings/smsSettings";

const Rendezvous = () => {
  const { data = [] } = useFetchRendezvousQuery();

  const { data: AllParents = [] } = useFetchParentsQuery();

  const { data: AllSmsSettings, isLoading: smsSettingsLoadStatus = [] } =
    useFetchSmsSettingsQuery();

  const [deleteRendezvous] = useDeleteRendezvousMutation();
  const [bulkDeleteRendezvous] = useBulkDeleteRendezvousMutation();

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const handleRowSelected = (state: any) => {
    setSelectedRows(state.selectedRows);
  };

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) return;
    const result = await swalWithBootstrapButtons.fire({
      title: "Suppression groupée",
      text: `Supprimer ${selectedRows.length} rendez-vous sélectionné(s) ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimer !",
      cancelButtonText: "Annuler",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      const ids = selectedRows.map((r: any) => r._id);
      await bulkDeleteRendezvous(ids).unwrap();
      setToggleCleared(!toggleCleared);
      setSelectedRows([]);
      Swal.fire({ position: "center", icon: "success", title: `${ids.length} rendez-vous supprimé(s)`, showConfirmButton: false, timer: 2500 });
    }
  };

  const [showRendezvous, setShowRendezvous] = useState<boolean>(false);

  const notifySuccess = (msg: string) => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: msg,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const notifyError = (err: any) => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Sothing Wrong, ${err}`,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const AlertDelete = async (_id: any) => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteRendezvous(_id);
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "Le rendez-vous est supprimé.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "Le rendez-vous est en sécurité :)",
            "info"
          );
        }
      });
  };

  const optionColumnsTable = AllParents.map((parent: any) => ({
    value: parent?._id!,
    label: `${parent.prenom_parent} ${parent.nom_parent}`,
  }));

  const [selectedColumnValues, setSelectedColumnValues] = useState<any[]>([]);

  const handleSelectValueColumnChange = (selectedOption: any) => {
    const values = selectedOption.map((option: any) => option.value);
    setSelectedColumnValues(values);
  };

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const handleDateChange = (selectedDates: Date[]) => {
    setSelectedDate(selectedDates[0]);
  };

  const [selectedTime, setSelectedTime] = useState<Date | null>(null);

  const handleTimeChange = (selectedDates: Date[]) => {
    const time = selectedDates[0];
    setSelectedTime(time);
  };

  const [modal_AddRendezvous, setmodal_AddRendezvous] =
    useState<boolean>(false);
  function tog_AddRendezvous() {
    setmodal_AddRendezvous(!modal_AddRendezvous);
  }

  const [modal_UpdateRendezvous, setmodal_UpdateRendezvous] =
    useState<boolean>(false);
  function tog_UpdateRendezvous() {
    setmodal_UpdateRendezvous(!modal_UpdateRendezvous);
  }

  const [updateAvisSmsSetting] = useUpdateSmsSettingByIdMutation();
  const [formData, setFormData] = useState({
    id: "",
    status: "",
  });

  useEffect(() => {
    if (AllSmsSettings !== undefined && smsSettingsLoadStatus === false) {
      const devoir_sms_setting = AllSmsSettings?.filter(
        (parametre) => parametre.service_name === "Rendez-vous"
      );
      setFormData((prevState) => ({
        ...prevState,
        id: devoir_sms_setting[0]?._id!,
        status: devoir_sms_setting[0]?.sms_status!,
      }));
    }
  }, [AllSmsSettings, smsSettingsLoadStatus]);

  const onChangeDocumentSmsSetting = () => {
    let updateData = {
      id: formData.id,
      status: formData.status === "1" ? "0" : "1",
    };
    updateAvisSmsSetting(updateData)
      .then(() =>
        setFormData((prevState) => ({
          ...prevState,
          status: formData.status === "1" ? "0" : "1",
        }))
      )
      .then(() =>
        notifySuccess("Paramètre Rendez-vous SMS a été modifié avec succès")
      );
  };

  const [createRendezvous] = useAddRendezvousMutation();

  const initialRendezvous = {
    titre: "",
    date: "",
    description: "",
    parents: [""],
    heure: "",
    administration: "",
    createdBy: "",
  };

  const [rendezvous, setRendezvous] = useState(initialRendezvous);

  const {
    titre,
    date,
    description,
    parents,
    heure,
    administration,
    createdBy,
  } = rendezvous;

  const onChangeRendezvous = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRendezvous((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const onSubmitRendezvous = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      rendezvous["date"] = formatDate(selectedDate);
      rendezvous["parents"] = selectedColumnValues;
      rendezvous["administration"] = "true";
      rendezvous["createdBy"] = "administration";
      rendezvous["heure"] = formatTime(selectedTime);
      createRendezvous(rendezvous)
        .then(() => notifySuccess("Le rendez-vous a été créé avec succès"))
        .then(() => setRendezvous(initialRendezvous));
    } catch (error) {
      notifyError(error);
    }
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Titre</span>,
      selector: (row: any) => row.titre,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Parent(s)</span>,
      selector: (row: any) => {
        return (
          <ul className="vstack gap-2 list-unstyled mb-0">
            {row.parents.map((parent: any) => (
              <li key={parent._id}>
                {parent.prenom_parent} {parent.nom_parent}
              </li>
            ))}
          </ul>
        );
      },
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Date du rendez-vous</span>,
      selector: (row: any) => row.date,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Heure</span>,
      selector: (row: any) => row.heure,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Actions</span>,
      sortable: true,
      cell: (row: any) => {
        return (
          <ul className="hstack gap-2 list-unstyled mb-0">
            <li>
              <Link
                to="#"
                className="badge badge-soft-info edit-item-btn"
                onClick={() => setShowRendezvous(!showRendezvous)}
                state={row}
              >
                <i
                  className="ri-eye-line"
                  style={{
                    transition: "transform 0.3s ease-in-out",
                    cursor: "pointer",
                    fontSize: "1.2em",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.3)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                ></i>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="badge badge-soft-success edit-item-btn"
                onClick={() => tog_UpdateRendezvous()}
                state={row}
              >
                <i
                  className="ri-edit-2-line"
                  style={{
                    transition: "transform 0.3s ease-in-out",
                    cursor: "pointer",
                    fontSize: "1.2em",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.3)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                ></i>
              </Link>
            </li>
            <li>
              <Link to="#" className="badge badge-soft-danger remove-item-btn">
                <i
                  className="ri-delete-bin-2-line"
                  style={{
                    transition: "transform 0.3s ease-in-out",
                    cursor: "pointer",
                    fontSize: "1.2em",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.3)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                  onClick={() => AlertDelete(row._id)}
                ></i>
              </Link>
            </li>
          </ul>
        );
      },
    },
  ];

  const rendezvousLocation = useLocation();

  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const getFilteredRendezvous = () => {
    let filteredRendezvous = data;

    if (searchTerm) {
      filteredRendezvous = filteredRendezvous.filter((rendezvous: any) => {
        const matchTitre = rendezvous?.titre
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const matchDescription = rendezvous?.description
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const matchDate = rendezvous?.date
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const matchHeure = rendezvous?.heure
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());

        const matchParents = rendezvous.parents.some((parent: any) => {
          return (
            parent.nom_parent
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            parent.prenom_parent
              .toLowerCase()
              .includes(searchTerm.toLowerCase())
          );
        });

        return (
          matchTitre ||
          matchDescription ||
          matchDate ||
          matchHeure ||
          matchParents
        );
      });
    }

    return filteredRendezvous;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Rendez-vous" pageTitle="Tableau de bord" />
          <Col lg={12}>
            <Card id="shipmentsList">
              <Card.Header className="border-bottom-dashed">
                <Row className="g-3">
                  <Col lg={3}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Rechercher ..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={3} className="text-center">
                        <Form.Label>Status SMS: </Form.Label>
                      </Col>
                      <Col lg={2}>
                        <div className="form-check form-switch">
                          <input
                            key={formData?.id!}
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={formData.id}
                            checked={formData.status === "1"}
                            onChange={() => onChangeDocumentSmsSetting()}
                          />
                          {formData.status === "0" ? (
                            <span className="badge bg-warning-subtle text-warning badge-border">
                              Désactivé
                            </span>
                          ) : (
                            <span className="badge bg-info-subtle text-info badge-border">
                              Activé
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={3} className="d-flex justify-content-end">
                    <div
                      className="btn-group btn-group-sm"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => tog_AddRendezvous()}
                      >
                        <i
                          className="ri-add-fill align-middle"
                          style={{
                            transition: "transform 0.3s ease-in-out",
                            cursor: "pointer",
                            fontSize: "1.5em",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.3)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        ></i>{" "}
                        <span>Ajouter Rendez-vous</span>
                      </button>
                    </div>
                  </Col>
                </Row>
              </Card.Header>
              {selectedRows.length > 0 && (
                <div className="bg-primary-subtle border-bottom p-3 d-flex align-items-center gap-3">
                  <span className="fw-semibold text-primary">
                    {selectedRows.length} sélectionné(s)
                  </span>
                  <Button variant="danger" size="sm" onClick={handleBulkDelete} className="d-flex align-items-center gap-1">
                    <i className="ri-delete-bin-2-line" />
                    Supprimer
                  </Button>
                  <Button variant="soft-secondary" size="sm" onClick={() => { setToggleCleared(!toggleCleared); setSelectedRows([]); }}>
                    <i className="ri-close-line me-1" />
                    Annuler
                  </Button>
                </div>
              )}
              <Card.Body>
                <DataTable
                  columns={columns}
                  data={getFilteredRendezvous()}
                  selectableRows
                  selectableRowsVisibleOnly
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  pagination
                />
              </Card.Body>
            </Card>
          </Col>
          <Modal
            className="fade"
            id="createModal"
            show={modal_AddRendezvous}
            onHide={() => {
              tog_AddRendezvous();
            }}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="bg-primary-subtle">
              <h5 className="modal-title d-flex align-items-center gap-2">
                <i className="ri-calendar-event-line fs-20" />
                Nouveau rendez-vous
              </h5>
            </Modal.Header>
            <Modal.Body className="px-4 py-3">
              <Form className="create-form" onSubmit={onSubmitRendezvous}>
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-information-line me-1" />
                  Informations du rendez-vous
                </p>
                <Row className="g-3 mb-4">
                  <Col md={12}>
                    <Form.Label htmlFor="titre" className="fw-medium">
                      <i className="ri-text me-1 text-primary" />
                      Titre <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="titre"
                      name="titre"
                      onChange={onChangeRendezvous}
                      value={rendezvous.titre}
                      placeholder="Titre du rendez-vous"
                      required
                    />
                  </Col>
                  <Col md={12}>
                    <Form.Label htmlFor="description" className="fw-medium">
                      <i className="ri-align-left me-1 text-muted" />
                      Description
                    </Form.Label>
                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      value={rendezvous.description}
                      onChange={onChangeRendezvous}
                      rows={3}
                      placeholder="Détails du rendez-vous..."
                    ></textarea>
                  </Col>
                </Row>

                <hr className="text-muted" />
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-time-line me-1" />
                  Date & Heure
                </p>
                <Row className="g-3 mb-4">
                  <Col md={6}>
                    <Form.Label htmlFor="date" className="fw-medium">
                      <i className="ri-calendar-line me-1 text-success" />
                      Date <span className="text-danger">*</span>
                    </Form.Label>
                    <Flatpickr
                      className="form-control"
                      placeholder="Sélectionner la date"
                      onChange={handleDateChange}
                      options={{
                        dateFormat: "d M, Y",
                        locale: French,
                      }}
                      id="date"
                      name="date"
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label htmlFor="heure" className="fw-medium">
                      <i className="ri-time-line me-1 text-info" />
                      Heure <span className="text-danger">*</span>
                    </Form.Label>
                    <Flatpickr
                      className="form-control"
                      placeholder="Sélectionner l'heure"
                      options={{
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: "H:i",
                        time_24hr: true,
                      }}
                      onChange={handleTimeChange}
                    />
                  </Col>
                </Row>

                <hr className="text-muted" />
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-parent-line me-1" />
                  Participants
                </p>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Label htmlFor="parents" className="fw-medium">
                      <i className="ri-user-heart-line me-1 text-warning" />
                      Parent(s) <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      isMulti
                      options={optionColumnsTable}
                      onChange={handleSelectValueColumnChange}
                      placeholder="Sélectionner les parents..."
                    />
                  </Col>
                </Row>
                <div className="hstack gap-2 justify-content-end border-top mt-4 pt-3">
                  <Button
                    variant="light"
                    onClick={() => {
                      tog_AddRendezvous();
                      setRendezvous(initialRendezvous);
                    }}
                  >
                    <i className="ri-close-line me-1" />
                    Annuler
                  </Button>
                  <Button
                    onClick={() => {
                      tog_AddRendezvous();
                    }}
                    type="submit"
                    variant="primary"
                    id="addNew"
                  >
                    <i className="ri-check-line me-1" />
                    Enregistrer
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </Container>
        <Modal
          className="fade"
          id="createModal"
          show={modal_UpdateRendezvous}
          onHide={() => {
            tog_UpdateRendezvous();
          }}
          centered
        >
          <Modal.Header closeButton>
            <h1 className="modal-title fs-5" id="createModalLabel">
              Modifier Rendez-vous
            </h1>
          </Modal.Header>
          <Modal.Body>
            <UpdateRendezvous
              modal_UpdateRendezvous={modal_UpdateRendezvous}
              setmodal_UpdateRendezvous={setmodal_UpdateRendezvous}
            />
          </Modal.Body>
        </Modal>
        <Offcanvas
          show={showRendezvous}
          onHide={() => setShowRendezvous(!showRendezvous)}
          placement="end"
          style={{ width: "40%" }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Détails du rendez-vous</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Row className="mb-3">
              <Col lg={4}>
                <span className="fw-medium">Titre</span>
              </Col>
              <Col lg={8}>
                <i>{rendezvousLocation?.state?.titre!}</i>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={4}>
                <span className="fw-medium">Description</span>
              </Col>
              <Col lg={8}>
                <i>{rendezvousLocation?.state?.description!}</i>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={4}>
                <span className="fw-medium">Date rendez-vous</span>
              </Col>
              <Col lg={8}>
                <i>{rendezvousLocation?.state?.date!}</i>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={4}>
                <span className="fw-medium">Heure</span>
              </Col>
              <Col lg={8}>
                <i>{rendezvousLocation?.state?.heure!}</i>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={4}>
                <span className="fw-medium">Parent(s)</span>
              </Col>
              <Col lg={8}>
                <ul className="vstack gap-2 list-unstyled mb-0">
                  {rendezvousLocation?.state?.parents.map((parent: any) => (
                    <li key={parent._id}>
                      {parent.prenom_parent} {parent.nom_parent}
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
            {rendezvousLocation?.state?.matiere! !== null && (
              <Row className="mb-3">
                <Col lg={4}>
                  <span className="fw-medium">Matiere</span>
                </Col>
                <Col lg={8}>
                  <i>{rendezvousLocation?.state?.matiere?.nom_matiere!}</i>
                </Col>
              </Row>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </React.Fragment>
  );
};
export default Rendezvous;
